<section
  class="relative overflow-hidden rounded-[2rem] border border-orange-200/50 bg-[#fbf6ef] px-6 py-10 sm:px-10 sm:py-12"
>
  <div
    class="pointer-events-none absolute -top-24 -right-20 h-72 w-72 rounded-full bg-orange-300/20 blur-3xl"
  ></div>
  <div
    class="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-amber-400/20 blur-3xl"
  ></div>

  <div class="relative z-10 flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
    <!-- LADO IZQUIERDO: ícono -->
    <div class="flex-shrink-0 flex flex-col items-center lg:items-center gap-4">
      <img
        src="https://res.cloudinary.com/dgjd3ybs1/image/upload/v1777736282/DInno-division_b5vbj1.png"
        alt="Divisor de cuentas"
        class="w-40 lg:w-48 object-contain drop-shadow-xl"
      />
      <span
        class="rounded-full border border-orange-200 bg-white/80 px-4 py-1.5 text-xs font-black uppercase tracking-[0.18em] text-orange-600 shadow-sm whitespace-nowrap"
      >
        Divisor de cuentas
      </span>
    </div>

    <!-- LADO DERECHO: texto + acordeón + CTA -->
    <div class="flex-1 flex flex-col items-center lg:items-start text-center lg:text-left">
      <h2 class="text-3xl font-black leading-tight tracking-tight text-[#1f1b16] sm:text-4xl">
        Dividí la cuenta
        <br />
        sin hacer cuentas
      </h2>

      <p class="mt-3 max-w-lg text-base leading-7 text-[#3a332c]/75">
        Escaneá el ticket, sumá a tu grupo y dejá que cada persona marque lo que consumió. Dinno
        calcula cuánto paga cada uno.
      </p>

      <!-- Acordeón -->
      <div
        class="mt-5 w-full max-w-lg rounded-[1.5rem] border border-orange-200/70 bg-white/75 p-4 text-left shadow-sm backdrop-blur"
      >
        <button
          type="button"
          (click)="howItWorksOpen.set(!howItWorksOpen())"
          class="flex w-full items-center justify-between gap-3 text-left"
        >
          <div>
            <h3 class="text-sm font-bold text-[#1f1b16]">¿Cómo funciona?</h3>
            <p class="mt-0.5 text-xs text-[#3a332c]/65">
              Mirá en pocos pasos cómo Dinno divide la cuenta.
            </p>
          </div>
          <lucide-icon
            [img]="ChevronDown"
            class="h-5 w-5 text-orange-500 transition-transform duration-200"
            [class.rotate-180]="howItWorksOpen()"
          >
          </lucide-icon>
        </button>

        @if (howItWorksOpen()) {
          <div class="mt-4 space-y-3 border-t border-orange-100 pt-4">
            @for (
              step of [
                {
                  number: 1,
                  title: 'Cargás la cuenta',
                  text: 'Podés escanear el ticket o ingresar los consumos manualmente.',
                },
                {
                  number: 2,
                  title: 'Sumás a las personas',
                  text: 'Las agregás vos o compartís un link/QR para que se unan.',
                },
                {
                  number: 3,
                  title: 'Cada uno marca lo suyo',
                  text: 'Los participantes eligen qué consumieron, o el anfitrión puede hacerlo.',
                },
                {
                  number: 4,
                  title: 'Revisás y compartís',
                  text: 'Dinno calcula cuánto paga cada uno y podés compartir el resultado.',
                },
              ];
              track step.number
            ) {
              <div class="flex gap-3">
                <div
                  class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-orange-100 text-xs font-black text-orange-600"
                >
                  {{ step.number }}
                </div>
                <div>
                  <p class="text-sm font-semibold text-[#1f1b16]">{{ step.title }}</p>
                  <p class="text-xs leading-5 text-[#3a332c]/70">{{ step.text }}</p>
                </div>
              </div>
            }
          </div>
        }
      </div>

      <!-- CTA -->
      <button
        type="button"
        (click)="goToDivider()"
        class="mt-6 inline-flex items-center gap-2 rounded-2xl bg-gradient-to-r from-orange-500 to-amber-500 px-8 py-4 text-lg font-bold text-white shadow-xl shadow-orange-300/50 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-2xl"
      >
        Empezar división
        <lucide-icon [img]="ArrowRight" class="h-5 w-5"></lucide-icon>
      </button>
    </div>
  </div>
</section>
